import { useCallback, useMemo } from 'react';
import { useRouter } from 'next/router';
import queryStringHelper from 'query-string';
import { useMerchantPath } from '@domain/merchants/hooks/useMerchantPath';
import { getQueryString } from '../functions';

type TQueryParams = Record<string, string>;

export const useGoToCheckoutOptionsPage = () => {
  const router = useRouter();
  const merchantPath = useMerchantPath();
  const queryString = getQueryString();

  const query = useMemo(() => {
    const innerQuery = queryStringHelper.parse(queryString);
    innerQuery.orderType = 'dinein';
    return innerQuery;
  }, [queryString]);
  const pathname = `${merchantPath}/checkout-type`;

  return useCallback(
    (queryParamsArg: TQueryParams = {}) => {
      router.push(
        {
          pathname,
          query: { ...query, ...queryParamsArg },
        },
        undefined,
        { shallow: true }
      );
    },
    [pathname, query, router]
  );
};
